import { format, differenceInDays, parseISO, isAfter, isBefore } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface ProgressBarProps {
  startDate?: number;
  endDate?: number;
}

export default function ProgressBar({ startDate, endDate }: ProgressBarProps) {
  // Retorna null se não tiver datas ou se a data final já passou
  if (!startDate || !endDate || isAfter(new Date(), new Date(endDate))) {
    return null;
  }

  const calculateProgress = () => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const today = new Date();

    // Se ainda não começou
    if (isAfter(start, today)) return 0;
    // Se já terminou
    if (isAfter(today, end)) return 100;

    const totalDays = differenceInDays(end, start);
    const daysElapsed = differenceInDays(today, start);
    
    return Math.min(100, Math.max(0, (daysElapsed / totalDays) * 100));
  };

  const formatDate = (date?: string | number) => {
    if (!date) return '';
    const parsedDate = typeof date === 'number' ? new Date(date) : parseISO(date);
    return format(parsedDate, 'dd/MM/yyyy', { locale: ptBR });
  };

  const progress = calculateProgress();

  return (
    <div className="flex items-center space-x-2">
      <p className="font-thin text-[10px] whitespace-nowrap">
        De {formatDate(startDate)}
      </p>

      <div className={`w-full rounded-2xl h-[10px] border border-[#C7D3EB] relative`}>
        <div 
          className="absolute top-[-1px] left-[-1px] rounded-2xl bg-[#FF3E5A] h-[10.5px] transition-all duration-300" 
          style={{ width: `calc(${progress ? progress : 3}% + 2px)` }}
        ></div>
      </div>

      <p className="font-thin text-[10px] whitespace-nowrap">
        Até {formatDate(endDate)}
      </p>
    </div>
  );
}